//Category
  // 1	Active
  // 2	Suspended
  // 3	Terminated
  // 4	Pending for Activation
  
  const categoryStatus = {
    1: [
      {
        id: 1,
        name: "Active",
      },
      {
        id: 2,
        name: "Suspended",
      },
      {
        id: 3,
        name: "Terminated",
      },
    ],
    2: [
      {
        id: 2,
        name: "Suspended",
      },
      {
        id: 1,
        name: "Active",
      },
      {
        id: 3,
        name: "Terminated",
      },
    ],
    3: [
      {
        id: 3,
        name: "Terminated",
      },
    ],
    4: [
      {
        id: 4,
        name: "Pending for Activation",
      },
      {
        id: 1,
        name: "Active",
      },
    ],
  };
  export const getCategoryStatus = function(initialStatus) {
    if (categoryStatus.hasOwnProperty(initialStatus)) {
      return categoryStatus[initialStatus];
    } else {
      return [];
    }
  };
  
  //Attachment
  // 1	Active
  // 2	Inactive
  
  const attachmentStatus = {
    1: [
      {
        id: 1,
        name: "Active",
      },
      {
        id: 2,
        name: "Inactive",
      },
    ],
    2: [
      {
        id: 2,
        name: "Inactive",
      },
      {
        id: 1,
        name: "Active",
      },
    ],
  };
  export const getAttachmentStatus = function(initialStatus) {
    if (attachmentStatus.hasOwnProperty(initialStatus)) {
      return attachmentStatus[initialStatus];
    } else {
      return [];
    }
  };
  
  const gridStatus = {
    1: [
      {
        id: 1,
        name: "Active",
      },
      {
        id: 2,
        name: "Suspended",
      },
      {
        id: 3,
        name: "Terminated",
      },
    ],
    2: [
      {
        id: 2,
        name: "Suspended",
      },
      {
        id: 1,
        name: "Active",
      },
      {
        id: 3,
        name: "Terminated",
      },
    ],
    3: [
      {
        id: 3,
        name: "Terminated",
      },
    ],
    4: [
      {
        id: 4,
        name: "Pending for Activation",
      },
      {
        id: 1,
        name: "Active",
      },
    ],
  };
  export const getGridStatus = function(initialStatus) {
    if (gridStatus.hasOwnProperty(initialStatus)) {
      return gridStatus[initialStatus];
    } else {
      return [];
    }
  };
  